import { connect } from "react-redux";
import Menu from "./components";

const mapStateToProps = (state) => ({
  browserFilter: state.options.browserFilter,
});

export default connect(mapStateToProps, null)(Menu);
